import { HeaderWrapper, Layout, TableCell, TableLayout } from 'components/Hospital/PaginationForms';
import { adminCounselerListHeader, adminCounselerListWidth } from 'constants/pagination';
import { AdminCounselerListPaginationProps } from 'models/Admin/AdminPaginationTypes';
import AdminCounselerListPaginationTable from './AdminCounselerListPaginationTable';
import { getWidthRation } from 'utils/calculateWdith';
import { NothingDataInManagingPatientsPagination } from '../AddDiagnosisPage/NothingDataInPagination';
import CustomedPagination from 'components/Pagination/CustomedPagination';

const AdminCounselerListPagination = ({
    currentPage,
    totalPages,
    pageGroup,
    handlePageGroup,
    handlePageChange,
    currentData,
    initNumber,
    totalCount,
    clickScheduleManageButton,
    handleResetButton,
}: AdminCounselerListPaginationProps) => {
    return (
        <Layout>
            <TableLayout>
                <HeaderWrapper>
                    {adminCounselerListHeader.map((name, idx) => {
                        return (
                            <TableCell key={idx} $width={getWidthRation(adminCounselerListWidth[idx])} $type='header' $justifyContent='space-between' cellType={name.type}>
                                {name.title}
                            </TableCell>
                        );
                    })}
                </HeaderWrapper>
                {currentData?.length !== 0 ? (
                    <AdminCounselerListPaginationTable currentPage={currentPage} totalCount={totalCount} currentData={currentData} clickScheduleManageButton={clickScheduleManageButton} />
                ) : (
                    <NothingDataInManagingPatientsPagination initNumber={initNumber} handleResetButton={handleResetButton}/>
                )}
            </TableLayout>
            {currentData && totalPages !== 0 && (
                <CustomedPagination currentPage={currentPage} onChangeCurrentPage={handlePageChange} onChangeSectionIdx={handlePageGroup} sectionIndex={pageGroup} totalPages={totalPages} />
            )}
        </Layout>
    );
};

export default AdminCounselerListPagination;
